module.exports = {
  setApiKey: () => null,
};
